import React from 'react';
import styled from 'styled-components';
import { Box, Typography } from '@material-ui/core';
import { useTranslation } from 'react-i18next';

import { useInvitationValidQuery } from 'graphql/types';
import { useStateContext } from 'appointment-tool/context';
import { EView } from 'appointment-tool/constants/views';
import BACKGROUND_IMAGE from 'assets/images/base-background-image.jpg';
import { getUrlParamValue } from 'utils';
import { Loader } from 'common/components/Loader';
import { breakpoints } from 'appointment-tool/constants';

import { Controls } from '../Controls';
import { GoogleMaps } from '../GoogleMaps';
import { AppViewOverlay } from '../AppViewOverlay';

interface IProps {
    className?: string;
}

const BaseAppView: React.FC<IProps> = ({ className }) => {
    const { t } = useTranslation();
    const { view } = useStateContext();

    const invitationId = getUrlParamValue('invitation_id') ?? '';

    const { data, loading } = useInvitationValidQuery({
        variables: { invitationId },
    });
    const { invitationValid } = data || {};

    if (loading) {
        return (
            <Box
                alignItems="center"
                display="flex"
                height="100%"
                justifyContent="center"
            >
                <Loader />
            </Box>
        );
    }

    const invalidInvitationContent = (
        <>
            <Box display="flex" flexDirection="column">
                <Typography className="heading" color="primary" variant="h1">
                    {t('appointment.invalidHeader')}
                </Typography>
                <Box mb={6} mt={10}>
                    <Typography>{t('appointment.invalidMessage_1')}</Typography>
                </Box>

                <Typography>{t('appointment.invalidMessage_2')}</Typography>
            </Box>
        </>
    );

    const isNotStoreListView = view === EView.Appointment || !invitationValid;

    return (
        <div className={className}>
            <Controls>
                {!invitationValid && !loading && invalidInvitationContent}
            </Controls>

            <GoogleMaps className={isNotStoreListView ? 'hide' : ''} />

            {isNotStoreListView && (
                <Box className="appViewOverlayWrapper" pl={95} width="100%">
                    <AppViewOverlay />
                </Box>
            )}
        </div>
    );
};

export const AppView = styled(BaseAppView)`
    height: 100vh;
    position: relative;
    overflow: hidden;
    display: flex;

    .appViewOverlayWrapper {
        display: none;
    }

    .heading {
        font-weight: 800;
    }

    ${GoogleMaps}.hide {
        display: none;
    }

    ${AppViewOverlay} {
        background-image: url(${BACKGROUND_IMAGE});
        background-repeat: no-repeat;
        background-size: cover;
    }

    @media (${breakpoints.mediumMin}) {
        ${Controls} {
            min-width: 475px;
        }

        .appViewOverlayWrapper {
            display: block;
        }
    }
`;
